import React from 'react';

const AuthContext = React.createContext({loggedIn: false});
export default AuthContext;